<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import SelectorDialog from '@Quest/PortfolioScenarios/Components/SelectorDialog.vue';
    import PortfolioScenarioEditor from "@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor.vue";
    import { SelectorDialogViewModel } from "@Quest/PortfolioScenarios/Components/SelectorDialog";
    import { PortfolioScenarioEditorViewModel } from "@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor";

    @Component({
        components: {
            SelectorDialog,
            PortfolioScenarioEditor
        },
        props: {
            portfolioId: { type: String, required: true },
            corporateScenarioUrl: { type: String, required: true },
        }
    })
    export default class PortfolioScenarioNavigation extends Vue
    {
        get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
        get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
        get scenarioId() { return this.$route.params.scenarioId; }

        selectorDialog: SelectorDialogViewModel = new SelectorDialogViewModel();
        portfolioScenarioEditor: PortfolioScenarioEditorViewModel = new PortfolioScenarioEditorViewModel(this.workspaceId, this.$props.portfolioId); 

        getButtonClass(path: string): string
        {
            const routePrefix = `/portfolio-plan/${path}/`;
            return this.$route.path.startsWith(routePrefix) ? 'btn btn-secondary' : 'btn btn-outline-secondary';
        }

        showSelectorDialog()
        {
            this.$emit('selector-opened');
            this.selectorDialog.show(this.workspaceId, this.$props.portfolioId, this.scenarioId);
        }

        showScenarioEditor()
        {
            this.$emit('settings-opened');
            this.portfolioScenarioEditor.showEditor(this.workspaceId, this.$props.portfolioId,  this.scenarioId);
        }
    }
</script>

<template>
    <div>
        <PortfolioScenarioEditor :viewModel="portfolioScenarioEditor" />
        <SelectorDialog :viewModel="selectorDialog" />

        <div class="text-right align-self-end">
            <button type="button" title="Open Selector (AI Assistant)"
                    class="btn btn-success" 
                    style="padding: 0.7em 1em;" 
                    @click="showSelectorDialog">

                <i class="fa-solid fa-robot fa-lg mr-1"></i> Selector
            </button>

            <div class="btn-group" role="group">
                <a title="Project Settings" :class="getButtonClass('projects')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio-plan/projects/${workspaceId}/${tchProjectId}/${scenarioId}`">
                    <i class="fa-solid fa-table fa-lg"></i>
                </a>
                <a title="Project Selection" :class="getButtonClass('selection')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio-plan/selection/${workspaceId}/${tchProjectId}/${scenarioId}`">
                    <i class="fa-solid fa-list-check fa-lg"></i>
                </a>
                <a title="Project Schedule" :class="getButtonClass('schedule')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio-plan/schedule/${workspaceId}/${tchProjectId}/${scenarioId}`">
                    <i class="fa-regular fa-calendar fa-lg"></i>
                </a>
                <a title="Project Review" :class="getButtonClass('review')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio-plan/review/${workspaceId}/${tchProjectId}/${scenarioId}`">
                    <i class="fa-solid fa-database fa-lg"></i>
                </a>
                <a title="Project Approval" :class="getButtonClass('approval')" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio-plan/approval/${workspaceId}/${tchProjectId}/${scenarioId}`">
                    <i class="fa-solid fa-pen-nib fa-lg"></i>
                </a>
            </div>

            <a title="Profit & Loss Report" :class="getButtonClass('pnl')" style="padding: 0.7em 2em;" v-sanitizedHref="`/#/portfolio-plan/pnl/${workspaceId}/${tchProjectId}/${scenarioId}`">
                P&L
            </a>

            <button title="Portfolio Plan Settings" class="btn btn-outline-secondary" style="padding: 0.7em 1em;" @click="showScenarioEditor">
                <i class="fa fa-lg fa-cog"></i>
            </button>

            <div class="btn-group" role="group">
                <a title="Enterprise Plan" class="btn btn-outline-secondary" style="padding: 0.7em 1em;" v-sanitizedHref="corporateScenarioUrl">
                    <i class="fa-solid fa-sitemap fa-lg"></i>
                </a>
                <a title="Back to Portfolio Plans" class="btn btn-outline-secondary" style="padding: 0.7em 1em;" v-sanitizedHref="`/#/portfolio/plans/${workspaceId}/${tchProjectId}`">
                    <i class="fa-solid fa-door-open fa-lg"></i>
                </a>
            </div>
        </div>
    </div>
</template>